export default "__VITE_ASSET__BvEyJygF__"